export default {
  state:{
    info:{}
  },
  mutations:{
    loginInfoAdd(state,obj){
      state.info = obj;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js